import React from 'react';
import PropTypes from 'prop-types';
import { PhoneInventoryStats } from '../phones/PhoneInventoryStats';
import './PhoneSummaryWidget.css';

const PhoneSummaryWidget = ({ phoneInventory, onViewPhones }) => {
  return (
    <div className="phone-summary-widget">
      <div className="phone-summary-widget__header">
        <h3 className="phone-summary-widget__title">Phone Inventory</h3>
        <button
          className="btn linear-gradient yr-submitbtn"
          onClick={onViewPhones}
        >
          View All
        </button>
      </div>

      <PhoneInventoryStats
        totalCount={phoneInventory?.total || 0}
        assignedCount={phoneInventory?.assigned || 0}
        unassignedCount={phoneInventory?.unassigned ?? (phoneInventory?.available || 0)}
        a2pCount={phoneInventory?.sms_assigned || 0}
      />
    </div>
  );
};

PhoneSummaryWidget.propTypes = {
  phoneInventory: PropTypes.shape({
    total: PropTypes.number,
    assigned: PropTypes.number,
    available: PropTypes.number,
    sms_assigned: PropTypes.number,
    unassigned: PropTypes.number,
  }).isRequired,
  onViewPhones: PropTypes.func.isRequired,
};

export default PhoneSummaryWidget;
